export default __webpack_public_path__ + "static/media/ken.349c5c0a.jpg";